import styles from './../../assets/styles/_colors.scss';

const muiInputTheme = (theme) => {
  theme.overrides.MuiFormLabel = {
    root: {
      color: '#000',
      '&$focused': {
        color: '#000',
      },
      transform: 'translate(0, 1.5px) scale(1) !important',
      fontSize: '12px',
      textAlign: 'left',
    },
    error: {
      color: styles.error,
    },
    filled: {
      color: '#002',
    },
    required: {
      color: '#002',
    },
    asterisk: {
      color: '#F00',
    },
  };
};

export default muiInputTheme;
